import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { isActionOf } from "typesafe-actions";

import ListRenameModalTracked from "app/pages/sales-intelligence/sub-modules/opportunities/containers/ListRenameModal/ListRenameModalTrackedContainer";
import { updateOpportunityListAsync } from "app/pages/sales-intelligence/sub-modules/opportunities/store/action-creators";
import { updateOpportunityListNameThunk } from "app/pages/sales-intelligence/sub-modules/opportunities/store/effects";
import { selectOpportunityListUpdating } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import type { ShortOpportunityList } from "app/pages/sales-intelligence/modules/lists/types/types";

type Props = {
    list?: Readonly<ShortOpportunityList>;
    onClose(): void;
};

const ListRenameModalContainer = (props: Props) => {
    const { list, onClose } = props;
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const isBeingUpdated = useSelector(selectOpportunityListUpdating);

    useEffect(() => {
        setIsOpen(typeof list !== "undefined");
    }, [list]);

    async function handleRenameSubmit(name: string) {
        if (typeof list === "undefined") {
            return onClose();
        }

        const resultAction = await dispatch(updateOpportunityListNameThunk(name, list.id, list.country));
        const isSuccessfulAction = isActionOf(updateOpportunityListAsync.success);

        if (isSuccessfulAction(resultAction)) {
            onClose();
        }
    }

    return (
        <ListRenameModalTracked
            isOpen={isOpen}
            currentName={list?.friendlyName ?? ""}
            isBeingSubmitted={isBeingUpdated}
            onCancel={onClose}
            onSubmit={handleRenameSubmit}
        />
    );
};

export default ListRenameModalContainer;
